<template>
<router-view/>
</template>

<script>
import '@/components/Widgets'
import Vue from 'vue'

export default {
  name: 'App',
  created () {
    window.eventBus = new Vue({})
  },
}
</script>

<style lang="scss">
@import "~../src/style/chc";
</style>



// WEBPACK FOOTER //
// src/App.vue